import { React, useCallback, useContext, useState, useEffect, useRef } from 'react';
import QRCode from "react-qr-code";
import './Export.scss';
import ExportButton from './ExportButton.js';
import AppContext from './AppContext';

function Export() {
  const myContext = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [finalUrl, setFinalUrl] = useState("");
  const [qrLink, setQrLink] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  
  const processStarted = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    if (!processStarted.current) {
      processStarted.current = true;
      generateAndUpload();
    }

    return () => clearTimeout(timer);
  }, []);

  const generateAndUpload = async () => {
    try {
      const mergedImage = await mergeImages(myContext.imageSelected4);
      setFinalUrl(mergedImage);
      await uploadToImgBB(mergedImage);
    } catch (error) {
      setUploadError(true);
    }
  };

  const mergeImages = (imageDataArray) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      canvas.width = 480;
      canvas.height = 1440;
      const context = canvas.getContext('2d');

      const loadImage = (src) => {
        return new Promise((res) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = src;
          img.onload = () => res(img);
          img.onerror = () => {
            res(null);
          };
        });
      };

      Promise.all(imageDataArray.map(loadImage)).then((images) => {
        const frameImage = images[0];
        const photos = images.slice(1);

        if (frameImage) {
          context.drawImage(frameImage, 0, 0, 480, 1440);
        }

        const x = 36.5;
        const y_positions = [35, 335, 632, 933]; 

        photos.forEach((photo, index) => {
          if (photo && index < 4) {
            context.drawImage(photo, x, y_positions[index], 408, 271);
          }
        });

        resolve(canvas.toDataURL('image/jpeg', 0.9));
      }).catch(reject);
    });
  };

  const uploadToImgBB = async (base64Data) => {
    setIsUploading(true);
    setUploadError(false);
    try {
      let form = new FormData();
      form.append("image", base64Data.split(",")[1]);
      
      const apiKey = process.env.REACT_APP_IMGBB_API_KEY || "029dc7dafd414fbd967f6d45852daadc";
      const response = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, {
        method: 'post',
        body: form
      });
      const res = await response.json();
      
      if (res.success) {
        setQrLink(res.data.url);
      } else {
        throw new Error(res.error?.message || "Upload failed");
      }
    } catch (err) {
      setUploadError(true);
    } finally {
      setIsUploading(false);
    }
  };

  function done() {
    window.location.replace("/Home");
  }

  if (loading) {
    return (
      <div className="FrameDiv loading">
        <div className="brand-line-container loading-animation">
          <div className="line yellow"></div>
          <div className="line red"></div>
          <div className="line blue"></div>
          <div className="line green"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="FrameDiv">
      <h1 className="title">사진이 완성되었어요!</h1>
      <div className="exportContent">
        <div className="imageSection">
          {finalUrl ? (
            <img src={finalUrl} className='exportImg' alt="Final Result" />
          ) : (
            <div className="imagePlaceholder">이미지를 생성 중입니다...</div>
          )}
        </div>
        <div className="qrSection">
          <div className='qrcodeDiv'>
            {qrLink ? (
              <QRCode 
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={qrLink}
                viewBox={`0 0 256 256`}
              />
            ) : (
              <div className="qrStatus">
                {uploadError ? "QR 생성 실패" : (isUploading ? "업로드 중..." : "준비 중...")}
              </div>
            )}
          </div>
          <h1 className="qrCaption">QR코드를 촬영하여 사진을<br />
            다운로드하실 수 있습니다.<br />
            &#40;제한시간: 10분&#41;<br />
            사진은 해상도를 위해 <br />
            480x1440으로 저장됩니다.</h1>
          <div className="doneBtnWrapper" onClick={done}>
            <ExportButton />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Export;
